module.exports = __webpack_public_path__ + "img/BadenCampus.54780f7e.png";